import amplifyConfig from '../config';
import API_PATH from './endpoints';
import axiosInstance from '../utils/axios';
import type { AxiosResponse } from 'axios';
import type { CreateDeliveryLocationParams, DeleteDeliveryLocationParams, DeliveryLocationType, UpdateDeliveryLocationParams } from '../types/deliveryLocation';

const deliveryLocationAPI = {
  /**
   * 受渡場所一覧の取得
   * @return DeliveryLocationType[]
   */
  getDeliveryLocations: async () => {
    return axiosInstance.get<undefined, AxiosResponse<DeliveryLocationType[]>>(amplifyConfig.apiGateway.URL + API_PATH.DELIVERY_LOCATION.DELIVERY_LOCATION);
  },

  /**
   * 受渡場所の作成
   * @param CreateDeliveryLocationParams
   * @return DeliveryLocationType
   */
  createDeliveryLocation: async (params: CreateDeliveryLocationParams) => {
    return axiosInstance.post<CreateDeliveryLocationParams, AxiosResponse<DeliveryLocationType>>(amplifyConfig.apiGateway.URL + API_PATH.DELIVERY_LOCATION.DELIVERY_LOCATION, params);
  },

  /**
   * 受渡場所の更新
   * @param UpdateDeliveryLocationParamsClient
   * @return DeliveryLocationType
   */
  updateDeliveryLocation: async (params: UpdateDeliveryLocationParams) => {
    const { id, ...rest } = params;
    return axiosInstance.put<UpdateDeliveryLocationParams, AxiosResponse<DeliveryLocationType>>(amplifyConfig.apiGateway.URL + API_PATH.DELIVERY_LOCATION.DELIVERY_LOCATION + '/' + id, { ...rest });
  },

  /**
   * 受渡場所の削除
   * @param DeleteDeliveryLocationParams
   * @return DeliveryLocationType
   */
  deleteDeliveryLocation: async (params: DeleteDeliveryLocationParams) => {
    const { id } = params;
    return axiosInstance.delete<DeleteDeliveryLocationParams, AxiosResponse<DeliveryLocationType>>(amplifyConfig.apiGateway.URL + API_PATH.DELIVERY_LOCATION.DELIVERY_LOCATION + '/' + id);
  },
};

export default deliveryLocationAPI;
